export const assetsConstants = {
  CUSTOMER_LOGIN_IMAGE_URL: "/images/customerLoginImage.png",
  SHUTTERB_LOGIN_IMAGE_URL: "/images/shutterbLoginImage.png",
  ACCOUNT_SELECTION_IMAGE_URL: "/images/accountSelectionImage.png",
};
